<template>
    <el-card class="box-card">
        <div class="component-content">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="批量邮件查询" name="first">
                    <section class="content">
                        <el-table :data="dataHandled" style="margin-top:20px;width: 100%">
                            <el-table-column prop="id" label="id"></el-table-column>
                            <el-table-column prop="seqCode" label="唯一序号"></el-table-column>
                            <el-table-column prop="adminName" label="后台操作人"></el-table-column>
                            <el-table-column prop="userCount" label="上传记录数"></el-table-column>
                            <el-table-column prop="reason" label="发送原因"></el-table-column>
                            <el-table-column prop="resultCount" label="成功记录数"></el-table-column>
                            <el-table-column prop="fileName" label="文件名"></el-table-column>
                        </el-table>
                        <div class="pagination">
                            <el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
                                           :page-size="pageSize"
                                           layout="total, prev, pager, next, jumper" :total="totalRow">
                            </el-pagination>
                        </div>
                    </section>
                </el-tab-pane>
                <el-tab-pane label="批量邮件发送" name="second">
                    <el-form>
                        <el-form-item label="批量模板下载:">
                            <el-button type="primary" @click="downloadBatchTemplate">下载</el-button>
                        </el-form-item>
                        <el-form-item label="上传批量信息:">
                            <el-upload class="uploLangConfTranVoad-demo"
                                       :show-file-list="false"
                                       :on-success="handleUploadBatchMailExcelResult"
                                       :action="uploadBatchMailExcelUrl()"
                                       :on-change="handleUploadBatchMailExcelChange">
                                <el-button type="primary">上传</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                    <div>
                        <el-table :data="rulerData">
                            <el-table-column prop="field" label="字段名"></el-table-column>
                            <el-table-column prop="isFilled" label="填写规则"></el-table-column>
                            <el-table-column prop="desc" label="内容格式描述"></el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </el-card>
</template>

<script>
    import {
        mapState
    } from 'vuex';
    import paginationController from '../../mixins/pagination'
    import actionConfirm from '../../mixins/action_confirm'
    import mailApi from '../../service/mail_api'
    import {apis} from "../../lib/apis";
    import XLSX from 'xlsx';

    export default {
        name: "batch_mails",
        data () {
            return {
                activeName: "first",
                rulerData: [
                    {
                        field: 'sheet名',
                        isFilled: '必填',
                        desc: '格式为年月日第几次(例如2023年6月1日第一次上传 sheet为2023060101)。'
                    },
                    {
                        field: 'seqCode',
                        isFilled: '必填',
                        desc: '格式为年月日第几次(例如2023年6月1日第一次上传 此列全部为2023060101)。'
                    },
                    {
                        field: 'serverId',
                        isFilled: '必填',
                        desc: '区服id。'
                    },
                    {
                        field: 'shortId',
                        isFilled: 'shortId与rid必填其一',
                        desc: '短id(信息为游戏内个人信息面板的探索者账号后面的一串数字)。'
                    },
                    {
                        field: 'rid',
                        isFilled: 'shortId与rid必填其一',
                        desc: '玩家的完整id。'
                    },
                    {
                        field: 'templateId',
                        isFilled: '必填',
                        desc: '邮件模板id(管理后台-邮件管理-邮件模板的模板id列的值)。'
                    },
                    {
                        field: 'rewards',
                        isFilled: '可选',
                        desc: '奖励串格式，此项不填时，程序根据模板id查找到对接的奖励串进行填充。'
                    },
                    {
                        field: 'sendTime',
                        isFilled: '必填',
                        desc: '玩家在这个时间之后收到，格式为yyyyMMdd-HHmmss。'
                    },
                    {
                        field: 'reason',
                        isFilled: '必填',
                        desc: '操作原因。'
                    },
                    {
                        field: 'disableDays',
                        isFilled: '必填',
                        desc: '大于1的数值，邮件在玩家收到后多少天失效。'
                    }
                ]
            }
        },
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
                serverGameList: state => state.server.serverGameList,
                serverWorldList: state => state.server.serverWorldList,
            }),
        },
        mixins: [paginationController, actionConfirm],
        mounted() {
            this.findAllBatchMails();
        },
        methods: {
            handleClick(tab, event) {
                if (tab.name === 'first') {
                    this.findAllBatchMails();
                }
            },

            // 查询批量邮件
            findAllBatchMails() {
                var self = this;
                mailApi.findAllBatchMails({
                    token: self.token
                }).then(res => {
                    self.rawData = res;
                    self.totalRow = res.length;
                })
            },

            uploadBatchMailExcelUrl() {
                return apis.mail_batch_send_by_excel + '?token=' + this.token;
            },

            handleUploadBatchMailExcelResult(response, file, fileList) {
                console.log(response);
            },

            handleUploadBatchMailExcelChange(file, fileList) {
            },

            downloadBatchTemplate() {
                var arr = [
                    ["seqCode","serverId","shortId", "rid","templateId","rewards", "sendTime","reason", "disableDays"],
                    ["2023053101"]
                ];

                const ws= XLSX.utils.aoa_to_sheet(arr);

                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, '2023053101');

                XLSX.writeFile(wb, 'batch_template.xlsx');
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/mails/batch_mails.vue